<template>
  <v-container>
    <v-row class="overflow-y-auto" style="max-height: 600px;">
      <v-col cols="12">
        <div class="display-3 white--text text-center">Contact Sessions</div>
      </v-col>
      <v-col cols="12" lg="6" :key="index" v-for="(session, index) in sessions">
        <v-list-item class="rounded-lg list-item" @click="selectContactSession(session)">
          <v-list-item-icon class="mt-4 mr-4">
            <v-icon color="white" large>mdi-calendar-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text text-no-wrap">
              <b v-if="!session.sessionname">Session {{ index + 1 }}</b>
              <b v-else>{{ session.sessionname }}</b>
              from
              <b>{{ session.starts_at | formatDate('D MMM YYYY HH:mm') }}</b>
              to
              <b>{{ session.ends_at | formatDate('D MMM YYYY HH:mm') }}</b>
            </v-list-item-title>
            <v-list-item-subtitle class="white--text">
              For <b>{{ session.project.projectname }}</b>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" v-if="sessions.length === 0">
        <v-list-item class="rounded-lg list-item-no-hover" style="min-width: 600px;">
          <v-list-item-content>
            <v-list-item-title class="white--text font-italic text-center">
              No contact session to display
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FiltersMixin from "@/mixins/FiltersMixin";

export default {
  name: "ContactSessionSelector",
  mixins: [FiltersMixin],
  props: {
    sessions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    selectContactSession(session) {
      this.$emit('select', session);
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
.list-item {
  background-color: rgba(255, 255, 255, 0.2);
  transition: all 0.1s;
}

.list-item:hover {
  background-color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
}

.list-item-no-hover {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>